import { Grid, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import CustomTypography from '@/components/dataDisplay/CustomTypography'
import { USER_ROLES } from '@/constants/userRoles'
import { useAuth } from '@/features/authentication/contexts/AuthContext'
import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import GridFrequencyWidget from '@/features/dashboard/components/GridFrequencyWidget'
import SiteCountWidget from '@/features/dashboard/components/SiteCountWidget'
import UserCountWidget from '@/features/dashboard/components/UserCountWidget'
import { useLocationForDashboardData } from '@/features/dashboard/hooks/useLocationForDashboardData'
import { hasGridFrequency } from '@/features/dashboard/utils/gridFrequency'

function Dashboard() {
  const { t } = useTranslation()
  const { permissions } = usePermissions()

  const { loggedInUser } = useAuth()
  const hasCustomerUserRole = loggedInUser?.role === USER_ROLES.RESOURCE_OWNERS.value
  const location = useLocationForDashboardData()

  if (hasCustomerUserRole) {
    if (permissions.has('powerMeasurements')) {
      return <Navigate replace to={'/sites/power-measurements'} />
    }
    return <Navigate replace to={'/sites/unavailability'} />
  }

  return (
    <Stack direction={'column'} sx={{ mt: 2 }}>
      <CustomTypography gutterBottom variant="h5">
        {t('common.period.current')}
      </CustomTypography>
      <Grid container columnSpacing={2} direction="row" justifyContent="flex-start" rowGap={2}>
        {hasGridFrequency(location) && (
          <Grid size={{ xs: 2 }}>
            <GridFrequencyWidget location={location} />
          </Grid>
        )}
        <Grid size={{ xs: 2 }}>
          <SiteCountWidget />
        </Grid>
        <Grid size={{ xs: 2 }}>
          <UserCountWidget />
        </Grid>
      </Grid>
    </Stack>
  )
}

export default Dashboard
